/* eslint no-console:0 */
// Succeedo pack - entry point for the Succeedo SMB platform
// Loaded via: <%= javascript_pack_tag 'succeedo' %> in the Succeedo layout
//
// This pack imports Succeedo-specific CSS tokens.
// React components are registered in findbob-bundle.js.

import '../bundles/FindBob/components/Succeedo/tokens/succeedo.css';

import '@fortawesome/fontawesome-free/js/all';
import 'bootstrap3/dist/js/bootstrap';
import ahoy from 'ahoy.js';

$.ahoy = ahoy;
